module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "word-extract"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "form-box-validate",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择文件类型："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择文件类型",
      "filterable": true,
      "clearable": true
    },
    model: {
      value: (_vm.form.fileType),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileType", $$v)
      },
      expression: "form.fileType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "2层目录结构",
      "value": 1
    }
  }), _c('el-option', {
    attrs: {
      "label": "3层目录结构",
      "value": 2
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "上传文件："
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "loading": _vm.loading || false,
      "size": "medium",
      "type": "primary",
      "plain": false,
      "round": false,
      "icon": "el-icon-upload"
    }
  }, [_c('span', [_vm._v("请上传 Excel 文件")]), _c('input', {
    attrs: {
      "type": "file",
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    },
    on: {
      "change": function($event) {
        return _vm.change($event)
      }
    }
  })])], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-320e9c0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-320e9c0c","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/wordExtract.vue
// module id = 1190
// module chunks = 2